import { sortVariants } from "./utils";

function fillSmallProduct(product, productCardTemplate) {
  const productCard = productCardTemplate.content.cloneNode(true);
  const productImage = productCard.querySelector('img');

  const imageSrc = product.data?.['intersport-dk.myshopify.com_ImageUrls']?.value?.$values[0];
  const secondaryImageSrc = product.data?.['intersport-dk.myshopify.com_ImageUrls']?.value?.$values[1];
  const handle = product.data?.['intersport-dk.myshopify.com_ShopifyHandle']?.value;
  const vendor = product.data?.Vendor?.value;
  const displayNameHTML = product.displayName.replace('·', '<span class="text-accent">·</span>');

  // image 
  productImage.src = imageSrc ? imageSrc : secondaryImageSrc ? secondaryImageSrc : "";

  // text 
  if (productCard.querySelector('.product-card-vendor-wrapper')) productCard.querySelector('.product-card-vendor-wrapper').textContent = vendor;
  productCard.querySelector('a').href = '/products/' + handle;
  productCard.querySelector('.product-list-info a').href = '/products/' + handle;
  productCard.querySelector('.product-list-info a').innerHTML = `${vendor} - ${displayNameHTML}`;

  // price
  let salesPrice = product.salesPrice;

  productCard.querySelector('.product-card-price-wrapper .current-price').textContent = salesPrice + ' ' + relewiseData.current_currency_symbol;
  if (salesPrice < product.listPrice) {
    productCard.querySelector('.product-card-price-wrapper .compare-price').textContent = product.listPrice + ' ' + relewiseData.current_currency_symbol;
  } else {
    productCard.querySelector('.product-card-price-wrapper .current-price').classList.remove('text-accent');
    productCard.querySelector('.product-card-price-wrapper del').remove();
  }

  // ATC form 
  const sortedVariants = sortVariants(product.allVariants);
  const atcButton = productCard.querySelector('.self-start add-to-cart button');
  const firstInStockVariant = sortedVariants.find(variant => variant.data['intersport-dk.myshopify.com_SellableOnlineQuantity']?.value > 0);
  const firstVariantID = firstInStockVariant?.data['intersport-dk.myshopify.com_ShopifyHandle'].value.split('variant=')[1];

  if (atcButton) {
    const hasVariants = product.allVariants.length < 1;
    atcButton.setAttribute('data-variant-id', firstVariantID)
    atcButton.setAttribute('data-has-only-default-variant', hasVariants);
  }

  const selectTemplate = document.createElement('template');
  const selectElm = document.createElement('select');
  selectElm.id = 'select-product-variants-selector';
  selectElm.classList.add('rounded-full', 'px-2', 'py-0.5', 'text-2-medium', 'bg-background');
  sortedVariants.map((variant) => {
    const option = document.createElement('option');
    option.setAttribute('value', variant.data['intersport-dk.myshopify.com_ShopifyHandle'].value.split('variant=')[1]);
    option.setAttribute('data-available', variant.data['intersport-dk.myshopify.com_SellableOnlineQuantity']?.value > 0);
    option.toggleAttribute('disabled', variant.data['intersport-dk.myshopify.com_SellableOnlineQuantity']?.value < 1);
    option.innerText = variant.displayName;
    if (variant == firstInStockVariant) option.setAttribute('selected', 'selected');
    selectElm.appendChild(option);
  });
  selectTemplate.content.appendChild(selectElm);
  productCard.querySelector('.self-start add-to-cart template').remove();
  productCard.querySelector('.self-start add-to-cart').appendChild(selectTemplate);

  return productCard;
}

export default fillSmallProduct;